import { useLayoutEffect } from 'react';

const WELL_GUARDIAN_TITLE = 'Well Guardian - Total';

export default function useUpdateWgPageTitleAndFavicon() {
  useLayoutEffect(() => {
    const drillxTitle = document.title;
    const drillxIconLinks = document.querySelectorAll('link[rel*="icon"], link[rel="manifest"]');
    document.title = WELL_GUARDIAN_TITLE;
    const head = document.head || document.getElementsByTagName('head')[0];
    for (let i = drillxIconLinks.length - 1; i >= 0; --i) {
      head.removeChild(drillxIconLinks[i]);
    }
    const wgIconLink = document.createElement('link');
    wgIconLink.rel = 'icon';
    wgIconLink.type = 'image/png';
    wgIconLink.href = '/wg-favicon-16x16.png';
    head.appendChild(wgIconLink);

    return () => {
      document.title = drillxTitle;
      head.removeChild(wgIconLink);
      for (let i = drillxIconLinks.length - 1; i >= 0; --i) {
        head.appendChild(drillxIconLinks[i]);
      }
    };
  }, []);
}
